import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import styles from './AnimatedCard.module.css'

interface AnimatedCardProps {
  imageSrc: string
  altText: string
  top: string
  left: string
  width: string
  height: string
  boxShadow: string
  zIndex?: string
  enableAnimation?: boolean
}

const AnimatedCard: React.FC<AnimatedCardProps> = ({
  imageSrc,
  altText,
  top,
  left,
  width,
  height,
  boxShadow,
  zIndex = '0',
  enableAnimation = false,
}) => {
  return (
    <Box
      className={`${styles.animatedCard} ${enableAnimation ? styles.shake : ''}`}
      style={{
        top,
        left,
        width,
        height,
        boxShadow,
        zIndex,
      }}
    >
      <img src={imageSrc} alt={altText} />
    </Box>
  )
}

export default AnimatedCard
